<template>
<section class="container">

    <Scroll
      :data="dataList"
      :allLoaded="allLoaded"
      @pulldown="loadData"
      @loadUp="loadup"
      v-if="dataList.length"
    >
    <div class="dataList">
    <div class="recordItem" v-for="(item,index) in dataList" :key="index">
      <div class="dataItem_top">
        <div class="top_left">{{item.plateNo|filterCarCode}}</div>
        <div class="top_right">¥ {{item.payAmount|priceFormat}}</div>
      </div>
      <div class="dataItem_center">
        <div class="center_line">
          <div class="center_title">停车场</div>
          <div class="center_con">{{item.parkHeaderName}}</div>
        </div>
        <div class="center_line">
          <div class="center_title">入场时间</div>
          <div class="center_con">{{item.inTime}}</div>
        </div>
        <div class="center_line">
          <div class="center_title">支付时间</div>
          <div class="center_con">{{item.createAt}}</div>
        </div>
      </div>
      <div class="dataItem_bottom">
        <div class="delete" @click="deleteItem(item.id)">删除</div>
      </div>
    </div>
    </div>
   </Scroll>

   <div v-if="dataList.length" style="height:50px;"></div>
   <div class="no_mess" v-if="!dataList.length" @click="fetchData">
     <nomessage class="no_mess"></nomessage>
   </div>
</section>
</template>

<script>
import util from '../../../utils/util';
import nomessage from '../../../components/nomessage';
import { freeCall} from '../../../utils/api'
import Scroll from "../../../components/scroll";
import {mapState} from 'vuex';
export default {
  name: 'parkingRecord',
  props: {
    parkHeaderId:{
      type:Number,
      default:0
    },
    parkName:{
      type:String,
      default:''
    },
    tab:{
      type:Number,
      default:0
    }
  },
  components: {
    Scroll,
    nomessage
  },
  filters: {
    filterCarCode(value) {
      if(value.length > 4){
        return value ? value.slice(0, 2) + '·' + value.slice(2) : '';
      }else{
        return value
      }
    }
  },
  watch:{
    tab(value){
      if(value==1){
        this.fetchData();
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      pageNo:1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      dataList:[],
    }
  },
  mounted(){
   this.fetchData();
  },
  methods:{
    deleteCarNumber(id){
      let postInfo = {
        "id": id,
        'url':'/parking/rstParkBill/deleteTemporaryBill'
      }
      util.showLoading("正在删除...");
      freeCall(postInfo).then(res => {
        util.hideLoading();
        if (res.res.code === 10000) {
          this.pageNo = 1;
          util.showLoading()
          this.fetchData();
        }else{
          util.showToast("删除失败");
        }
      })

    },
    deleteItem(id){
      let self = this;
      util.showModal('', '确定删除缴费记录吗?', true, '确定',  () => {
        self.deleteCarNumber(id);
      }, () => {
      })
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading()
      this.fetchData();
    },
    fetchData(){
      util.hideLoading()
      let postInfo = {
        pages:this.pageNo,
        size: this.pageSize,
        parkHeaderId:this.parkHeaderId,
        openId: this.common.openId,
        url:'/parking/rstParkBill/queryTemporaryBillPage'
      }
      util.showLoading("加载中...");
      freeCall(postInfo).then(res => {
        console.log(res)
        this.loaded = true;
        util.hideLoading();
        if (res.res.code === 10000) {
          let data = res.body.data.list;
          if (data.length != 10) {
            this.allLoaded = true;
          }
          if (this.pageNo === 1) {
            this.dataList = data;
          } else {
            this.dataList = [...this.dataList, ...data];
          }
        } else {
          util.showToast(res.res.msg);
        }
      })


    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
  height:100vh;
  background: #F3F4F6;

  display: flex;
  flex-direction: column;
  .dataList{
    flex: 1;
    padding-top: 20px;
  }
  .recordItem{
    margin: 0 20px 20px;
    width: 710px;
    border-radius: 8px;
    background: #fff;
    .dataItem_top{
      height: 88px;
      display: flex;
      padding: 0 28px;
      align-items: center;
      border-bottom: 1px solid #EAEAEA;
      .top_left{
        flex: 1;
        text-align: left;
        font-size:32px;
        color: #333;
      }
      .top_right{
        flex: 1;
        text-align: right;
        color: #FC3F56;
        font-size:28px;
      }
    }
    .dataItem_center{
      min-height: 192px;
      .center_line{
        display: flex;
        padding: 0 28px;
        align-items: center;
        height: 64px;
        .center_title{
          width: 152px;
          font-size:26px;
          color: #666;
        }
        .center_con{
          flex: 1;
          font-size:26px;
          color: #333;
        }
      }
    }
    .dataItem_bottom{
      height: 88px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 28px;
      box-sizing: border-box;
      .delete{
        width:128px;
        height:52px;
        border-radius:8px;
        border:2px solid rgba(218,218,218,1);
        font-size:26px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:52px;
        text-align: center;
      }
    }
  }
  .no_mess {
    height: 100vh;
    .flex();
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
